<template>
  <div class="dashboard">
    <section class="page">
      <div class="page__Pending">
        <icon name="users" />
        <h2>Your account is pending approval</h2>
        <p>
          Hey, thanks for getting on board! Seems your account is still pending approval and we highly recommend you
          contact one of your organisational representatives to speed things up and get approved soon.
        </p>

        <button @click="logOut()">Log-in with a different account</button>
        <a href=""></a>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'UserPending',
  methods: {
    logOut() {
      localStorage.removeItem('token')
      this.$router.push({ path: '/login' })
    },
  },
}
</script>
